import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './CountryCodeSelect.scss';

export const COUNTRIES = [
  { code: 'BR', name: 'Brasil', dial: '+55' },
  { code: 'AF', name: 'Afeganistão', dial: '+93' },
  { code: 'ZA', name: 'África do Sul', dial: '+27' },
  { code: 'AL', name: 'Albânia', dial: '+355' },
  { code: 'DE', name: 'Alemanha', dial: '+49' },
  { code: 'AD', name: 'Andorra', dial: '+376' },
  { code: 'AO', name: 'Angola', dial: '+244' },
  { code: 'AI', name: 'Anguilla', dial: '+1264' },
  { code: 'AQ', name: 'Antártida', dial: '+672' },
  { code: 'AG', name: 'Antígua e Barbuda', dial: '+1268' },
  { code: 'SA', name: 'Arábia Saudita', dial: '+966' },
  { code: 'DZ', name: 'Argélia', dial: '+213' },
  { code: 'AR', name: 'Argentina', dial: '+54' },
  { code: 'AM', name: 'Armênia', dial: '+374' },
  { code: 'AW', name: 'Aruba', dial: '+297' },
  { code: 'AU', name: 'Austrália', dial: '+61' },
  { code: 'AT', name: 'Áustria', dial: '+43' },
  { code: 'AZ', name: 'Azerbaijão', dial: '+994' },
  { code: 'BS', name: 'Bahamas', dial: '+1242' },
  { code: 'BH', name: 'Bahrein', dial: '+973' },
  { code: 'BD', name: 'Bangladesh', dial: '+880' },
  { code: 'BB', name: 'Barbados', dial: '+1246' },
  { code: 'BE', name: 'Bélgica', dial: '+32' },
  { code: 'BZ', name: 'Belize', dial: '+501' },
  { code: 'BJ', name: 'Benin', dial: '+229' },
  { code: 'BM', name: 'Bermudas', dial: '+1441' },
  { code: 'BY', name: 'Bielorrússia', dial: '+375' },
  { code: 'BO', name: 'Bolívia', dial: '+591' },
  { code: 'BA', name: 'Bósnia e Herzegovina', dial: '+387' },
  { code: 'BW', name: 'Botsuana', dial: '+267' },
  { code: 'BN', name: 'Brunei', dial: '+673' },
  { code: 'BG', name: 'Bulgária', dial: '+359' },
  { code: 'BF', name: 'Burkina Faso', dial: '+226' },
  { code: 'BI', name: 'Burundi', dial: '+257' },
  { code: 'BT', name: 'Butão', dial: '+975' },
  { code: 'CV', name: 'Cabo Verde', dial: '+238' },
  { code: 'CM', name: 'Camarões', dial: '+237' },
  { code: 'KH', name: 'Camboja', dial: '+855' },
  { code: 'CA', name: 'Canadá', dial: '+1' },
  { code: 'QA', name: 'Catar', dial: '+974' },
  { code: 'KZ', name: 'Cazaquistão', dial: '+7' },
  { code: 'TD', name: 'Chade', dial: '+235' },
  { code: 'CL', name: 'Chile', dial: '+56' },
  { code: 'CN', name: 'China', dial: '+86' },
  { code: 'CY', name: 'Chipre', dial: '+357' },
  { code: 'CO', name: 'Colômbia', dial: '+57' },
  { code: 'KM', name: 'Comores', dial: '+269' },
  { code: 'CG', name: 'Congo', dial: '+242' },
  { code: 'CD', name: 'Congo (RDC)', dial: '+243' },
  { code: 'KP', name: 'Coreia do Norte', dial: '+850' },
  { code: 'KR', name: 'Coreia do Sul', dial: '+82' },
  { code: 'CI', name: 'Costa do Marfim', dial: '+225' },
  { code: 'CR', name: 'Costa Rica', dial: '+506' },
  { code: 'HR', name: 'Croácia', dial: '+385' },
  { code: 'CU', name: 'Cuba', dial: '+53' },
  { code: 'CW', name: 'Curaçao', dial: '+599' },
  { code: 'DK', name: 'Dinamarca', dial: '+45' },
  { code: 'DJ', name: 'Djibuti', dial: '+253' },
  { code: 'DM', name: 'Dominica', dial: '+1767' },
  { code: 'EG', name: 'Egito', dial: '+20' },
  { code: 'SV', name: 'El Salvador', dial: '+503' },
  { code: 'AE', name: 'Emirados Árabes Unidos', dial: '+971' },
  { code: 'EC', name: 'Equador', dial: '+593' },
  { code: 'ER', name: 'Eritreia', dial: '+291' },
  { code: 'SK', name: 'Eslováquia', dial: '+421' },
  { code: 'SI', name: 'Eslovênia', dial: '+386' },
  { code: 'ES', name: 'Espanha', dial: '+34' },
  { code: 'US', name: 'Estados Unidos', dial: '+1' },
  { code: 'EE', name: 'Estônia', dial: '+372' },
  { code: 'SZ', name: 'Essuatíni', dial: '+268' },
  { code: 'ET', name: 'Etiópia', dial: '+251' },
  { code: 'FJ', name: 'Fiji', dial: '+679' },
  { code: 'PH', name: 'Filipinas', dial: '+63' },
  { code: 'FI', name: 'Finlândia', dial: '+358' },
  { code: 'FR', name: 'França', dial: '+33' },
  { code: 'GA', name: 'Gabão', dial: '+241' },
  { code: 'GM', name: 'Gâmbia', dial: '+220' },
  { code: 'GH', name: 'Gana', dial: '+233' },
  { code: 'GE', name: 'Geórgia', dial: '+995' },
  { code: 'GI', name: 'Gibraltar', dial: '+350' },
  { code: 'GD', name: 'Granada', dial: '+1473' },
  { code: 'GR', name: 'Grécia', dial: '+30' },
  { code: 'GL', name: 'Groenlândia', dial: '+299' },
  { code: 'GP', name: 'Guadalupe', dial: '+590' },
  { code: 'GU', name: 'Guam', dial: '+1671' },
  { code: 'GT', name: 'Guatemala', dial: '+502' },
  { code: 'GG', name: 'Guernsey', dial: '+44' },
  { code: 'GY', name: 'Guiana', dial: '+592' },
  { code: 'GF', name: 'Guiana Francesa', dial: '+594' },
  { code: 'GN', name: 'Guiné', dial: '+224' },
  { code: 'GQ', name: 'Guiné Equatorial', dial: '+240' },
  { code: 'GW', name: 'Guiné-Bissau', dial: '+245' },
  { code: 'HT', name: 'Haiti', dial: '+509' },
  { code: 'NL', name: 'Holanda', dial: '+31' },
  { code: 'HN', name: 'Honduras', dial: '+504' },
  { code: 'HK', name: 'Hong Kong', dial: '+852' },
  { code: 'HU', name: 'Hungria', dial: '+36' },
  { code: 'YE', name: 'Iêmen', dial: '+967' },
  { code: 'BV', name: 'Ilha Bouvet', dial: '+47' },
  { code: 'CX', name: 'Ilha Christmas', dial: '+61' },
  { code: 'IM', name: 'Ilha de Man', dial: '+44' },
  { code: 'NF', name: 'Ilha Norfolk', dial: '+672' },
  { code: 'KY', name: 'Ilhas Cayman', dial: '+1345' },
  { code: 'CC', name: 'Ilhas Cocos', dial: '+61' },
  { code: 'CK', name: 'Ilhas Cook', dial: '+682' },
  { code: 'FO', name: 'Ilhas Faroe', dial: '+298' },
  { code: 'FK', name: 'Ilhas Malvinas', dial: '+500' },
  { code: 'MP', name: 'Ilhas Marianas do Norte', dial: '+1670' },
  { code: 'MH', name: 'Ilhas Marshall', dial: '+692' },
  { code: 'SB', name: 'Ilhas Salomão', dial: '+677' },
  { code: 'TC', name: 'Ilhas Turcas e Caicos', dial: '+1649' },
  { code: 'VI', name: 'Ilhas Virgens Americanas', dial: '+1340' },
  { code: 'VG', name: 'Ilhas Virgens Britânicas', dial: '+1284' },
  { code: 'IN', name: 'Índia', dial: '+91' },
  { code: 'ID', name: 'Indonésia', dial: '+62' },
  { code: 'IR', name: 'Irã', dial: '+98' },
  { code: 'IQ', name: 'Iraque', dial: '+964' },
  { code: 'IE', name: 'Irlanda', dial: '+353' },
  { code: 'IS', name: 'Islândia', dial: '+354' },
  { code: 'IL', name: 'Israel', dial: '+972' },
  { code: 'IT', name: 'Itália', dial: '+39' },
  { code: 'JM', name: 'Jamaica', dial: '+1876' },
  { code: 'JP', name: 'Japão', dial: '+81' },
  { code: 'JE', name: 'Jersey', dial: '+44' },
  { code: 'JO', name: 'Jordânia', dial: '+962' },
  { code: 'KI', name: 'Kiribati', dial: '+686' },
  { code: 'KW', name: 'Kuwait', dial: '+965' },
  { code: 'LA', name: 'Laos', dial: '+856' },
  { code: 'LS', name: 'Lesoto', dial: '+266' },
  { code: 'LV', name: 'Letônia', dial: '+371' },
  { code: 'LB', name: 'Líbano', dial: '+961' },
  { code: 'LR', name: 'Libéria', dial: '+231' },
  { code: 'LY', name: 'Líbia', dial: '+218' },
  { code: 'LI', name: 'Liechtenstein', dial: '+423' },
  { code: 'LT', name: 'Lituânia', dial: '+370' },
  { code: 'LU', name: 'Luxemburgo', dial: '+352' },
  { code: 'MO', name: 'Macau', dial: '+853' },
  { code: 'MK', name: 'Macedônia do Norte', dial: '+389' },
  { code: 'MG', name: 'Madagascar', dial: '+261' },
  { code: 'MY', name: 'Malásia', dial: '+60' },
  { code: 'MW', name: 'Malawi', dial: '+265' },
  { code: 'MV', name: 'Maldivas', dial: '+960' },
  { code: 'ML', name: 'Mali', dial: '+223' },
  { code: 'MT', name: 'Malta', dial: '+356' },
  { code: 'MA', name: 'Marrocos', dial: '+212' },
  { code: 'MQ', name: 'Martinica', dial: '+596' },
  { code: 'MU', name: 'Maurício', dial: '+230' },
  { code: 'MR', name: 'Mauritânia', dial: '+222' },
  { code: 'YT', name: 'Mayotte', dial: '+262' },
  { code: 'MX', name: 'México', dial: '+52' },
  { code: 'MM', name: 'Mianmar', dial: '+95' },
  { code: 'FM', name: 'Micronésia', dial: '+691' },
  { code: 'MZ', name: 'Moçambique', dial: '+258' },
  { code: 'MD', name: 'Moldávia', dial: '+373' },
  { code: 'MC', name: 'Mônaco', dial: '+377' },
  { code: 'MN', name: 'Mongólia', dial: '+976' },
  { code: 'ME', name: 'Montenegro', dial: '+382' },
  { code: 'MS', name: 'Montserrat', dial: '+1664' },
  { code: 'NA', name: 'Namíbia', dial: '+264' },
  { code: 'NR', name: 'Nauru', dial: '+674' },
  { code: 'NP', name: 'Nepal', dial: '+977' },
  { code: 'NI', name: 'Nicarágua', dial: '+505' },
  { code: 'NE', name: 'Níger', dial: '+227' },
  { code: 'NG', name: 'Nigéria', dial: '+234' },
  { code: 'NU', name: 'Niue', dial: '+683' },
  { code: 'NO', name: 'Noruega', dial: '+47' },
  { code: 'NC', name: 'Nova Caledônia', dial: '+687' },
  { code: 'NZ', name: 'Nova Zelândia', dial: '+64' },
  { code: 'OM', name: 'Omã', dial: '+968' },
  { code: 'PW', name: 'Palau', dial: '+680' },
  { code: 'PS', name: 'Palestina', dial: '+970' },
  { code: 'PA', name: 'Panamá', dial: '+507' },
  { code: 'PG', name: 'Papua-Nova Guiné', dial: '+675' },
  { code: 'PK', name: 'Paquistão', dial: '+92' },
  { code: 'PY', name: 'Paraguai', dial: '+595' },
  { code: 'PE', name: 'Peru', dial: '+51' },
  { code: 'PN', name: 'Pitcairn', dial: '+64' },
  { code: 'PF', name: 'Polinésia Francesa', dial: '+689' },
  { code: 'PL', name: 'Polônia', dial: '+48' },
  { code: 'PR', name: 'Porto Rico', dial: '+1787' },
  { code: 'PT', name: 'Portugal', dial: '+351' },
  { code: 'KE', name: 'Quênia', dial: '+254' },
  { code: 'KG', name: 'Quirguistão', dial: '+996' },
  { code: 'GB', name: 'Reino Unido', dial: '+44' },
  { code: 'CF', name: 'República Centro-Africana', dial: '+236' },
  { code: 'DO', name: 'República Dominicana', dial: '+1809' },
  { code: 'RE', name: 'Reunião', dial: '+262' },
  { code: 'RO', name: 'Romênia', dial: '+40' },
  { code: 'RW', name: 'Ruanda', dial: '+250' },
  { code: 'RU', name: 'Rússia', dial: '+7' },
  { code: 'EH', name: 'Saara Ocidental', dial: '+212' },
  { code: 'WS', name: 'Samoa', dial: '+685' },
  { code: 'AS', name: 'Samoa Americana', dial: '+1684' },
  { code: 'SM', name: 'San Marino', dial: '+378' },
  { code: 'SH', name: 'Santa Helena', dial: '+290' },
  { code: 'LC', name: 'Santa Lúcia', dial: '+1758' },
  { code: 'BL', name: 'São Bartolomeu', dial: '+590' },
  { code: 'KN', name: 'São Cristóvão e Névis', dial: '+1869' },
  { code: 'MF', name: 'São Martinho (parte francesa)', dial: '+590' },
  { code: 'PM', name: 'São Pedro e Miquelão', dial: '+508' },
  { code: 'ST', name: 'São Tomé e Príncipe', dial: '+239' },
  { code: 'VC', name: 'São Vicente e Granadinas', dial: '+1784' },
  { code: 'SC', name: 'Seicheles', dial: '+248' },
  { code: 'SN', name: 'Senegal', dial: '+221' },
  { code: 'SL', name: 'Serra Leoa', dial: '+232' },
  { code: 'RS', name: 'Sérvia', dial: '+381' },
  { code: 'SG', name: 'Singapura', dial: '+65' },
  { code: 'SX', name: 'Sint Maarten (parte holandesa)', dial: '+1721' },
  { code: 'SY', name: 'Síria', dial: '+963' },
  { code: 'SO', name: 'Somália', dial: '+252' },
  { code: 'LK', name: 'Sri Lanka', dial: '+94' },
  { code: 'SS', name: 'Sudão do Sul', dial: '+211' },
  { code: 'SD', name: 'Sudão', dial: '+249' },
  { code: 'SE', name: 'Suécia', dial: '+46' },
  { code: 'CH', name: 'Suíça', dial: '+41' },
  { code: 'SR', name: 'Suriname', dial: '+597' },
  { code: 'SJ', name: 'Svalbard e Jan Mayen', dial: '+47' },
  { code: 'TH', name: 'Tailândia', dial: '+66' },
  { code: 'TW', name: 'Taiwan', dial: '+886' },
  { code: 'TJ', name: 'Tajiquistão', dial: '+992' },
  { code: 'TZ', name: 'Tanzânia', dial: '+255' },
  { code: 'CZ', name: 'Tchéquia', dial: '+420' },
  { code: 'IO', name: 'Território Britânico do Oceano Índico', dial: '+246' },
  { code: 'TL', name: 'Timor-Leste', dial: '+670' },
  { code: 'TG', name: 'Togo', dial: '+228' },
  { code: 'TK', name: 'Tokelau', dial: '+690' },
  { code: 'TO', name: 'Tonga', dial: '+676' },
  { code: 'TT', name: 'Trinidad e Tobago', dial: '+1868' },
  { code: 'TN', name: 'Tunísia', dial: '+216' },
  { code: 'TM', name: 'Turcomenistão', dial: '+993' },
  { code: 'TR', name: 'Turquia', dial: '+90' },
  { code: 'TV', name: 'Tuvalu', dial: '+688' },
  { code: 'UA', name: 'Ucrânia', dial: '+380' },
  { code: 'UG', name: 'Uganda', dial: '+256' },
  { code: 'UY', name: 'Uruguai', dial: '+598' },
  { code: 'UZ', name: 'Uzbequistão', dial: '+998' },
  { code: 'VU', name: 'Vanuatu', dial: '+678' },
  { code: 'VA', name: 'Vaticano', dial: '+39' },
  { code: 'VE', name: 'Venezuela', dial: '+58' },
  { code: 'VN', name: 'Vietnã', dial: '+84' },
  { code: 'WF', name: 'Wallis e Futuna', dial: '+681' },
  { code: 'ZM', name: 'Zâmbia', dial: '+260' },
  { code: 'ZW', name: 'Zimbábue', dial: '+263' },
];

export const DEFAULT_COUNTRY_CODE = '+55';

const PRIMARY_BY_DIAL = {
  '+1': 'US',
  '+7': 'RU',
  '+39': 'IT',
  '+44': 'GB',
  '+47': 'NO',
  '+61': 'AU',
  '+64': 'NZ',
  '+212': 'MA',
  '+262': 'RE',
  '+590': 'GP',
  '+599': 'CW',
  '+672': 'AQ',
};

const findCountryByDial = (dial) => {
  const preferredCode = PRIMARY_BY_DIAL[dial];
  if (preferredCode) {
    const preferred = COUNTRIES.find((c) => c.code === preferredCode);
    if (preferred) return preferred;
  }
  return COUNTRIES.find((c) => c.dial === dial) || COUNTRIES[0];
};

const flagUrl = (code) => `https://flagcdn.com/${code.toLowerCase()}.svg`;

const CountryCodeSelect = ({
  label = 'País',
  name = 'country_code',
  value = DEFAULT_COUNTRY_CODE,
  onChange,
  disabled = false,
  className = '',
  errorMessage = '',
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);
  const searchInputRef = useRef(null);

  const selected = useMemo(() => findCountryByDial(value), [value]);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return COUNTRIES;
    return COUNTRIES.filter(
      (c) =>
        c.name.toLowerCase().includes(term) ||
        c.dial.includes(term) ||
        c.code.toLowerCase().includes(term)
    );
  }, [search]);

  useEffect(() => {
    if (!open) return undefined;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
        setSearch('');
      }
    };
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        setSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [open]);

  useEffect(() => {
    if (open && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [open]);

  const handleToggle = () => {
    if (disabled) return;
    setOpen((prev) => !prev);
  };

  const handleSelect = useCallback(
    (country) => {
      setOpen(false);
      setSearch('');
      if (onChange) {
        onChange({ target: { name, value: country.dial } });
      }
    },
    [name, onChange]
  );

  return (
    <div
      className={`CountryCodeSelect ${className}`}
      ref={containerRef}
    >
      {label && <div className="title">{label}</div>}
      <button
        type="button"
        className={`trigger ${open ? 'open' : ''} ${errorMessage ? 'error' : ''}`}
        onClick={handleToggle}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <img
          className="flag"
          src={flagUrl(selected.code)}
          alt={`Bandeira ${selected.name}`}
          loading="lazy"
        />
        <span className="dial">{selected.dial}</span>
        <span className="country-code">{selected.code}</span>
        <svg
          className="chevron"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="dropdown" role="listbox">
          <div className="search-box">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Buscar país ou código"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <ul className="options">
            {filtered.length === 0 ? (
              <li className="empty">Nenhum país encontrado</li>
            ) : (
              filtered.map((country) => {
                const isActive = country.code === selected.code;
                return (
                  <li
                    key={country.code}
                    className={`option ${isActive ? 'active' : ''}`}
                    role="option"
                    aria-selected={isActive}
                    onClick={() => handleSelect(country)}
                  >
                    <img
                      className="flag"
                      src={flagUrl(country.code)}
                      alt={`Bandeira ${country.name}`}
                      loading="lazy"
                    />
                    <span className="name">{country.name}</span>
                    <span className="dial">{country.dial}</span>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      )}

      {errorMessage && <div className="input-error-msg">{errorMessage}</div>}
    </div>
  );
};

CountryCodeSelect.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default CountryCodeSelect;
